<template lang="">
    <v-card>
        
        <s-crud
            :config="config"
            title="Inductores"
            :filter="filter"
            add
            @add="send()"
            addNoFunction
            @rowSelected="rowSelected($event)"
            :single-row="false"
            ref="InductorsList"
        >
            <template v-slot:filter>
                <v-container>
                    <v-row>                        
                        <v-col>
                            <s-text
                                label="Número de artículo"
                                v-model="filter.ItemCode"
                            ></s-text>
                        </v-col>
                        <v-col>
                            <s-text
                                label="Descripción"
                                v-model="filter.ItemName"
                            ></s-text>
                        </v-col>
                        <v-col>
                            <s-text
                                label="Grupo de artículos"
                                v-model="filter.ItmsGrpNam"
                            ></s-text>
                        </v-col>
                        <v-col>
							<!--no-default clearable-->
							<s-select-definition label="Método de Valorización"  clearable 
								v-model="filter.EvalSystem" :def="1734" />
						</v-col>
                    </v-row>
                </v-container>
            </template>            
        </s-crud>
        <v-dialog persistent v-model="openModal" v-if="openModal" width="700">
			<v-card>
				<v-col>
					<v-row>
						<s-toolbar
							save
							@save="save({})"
							:color="'#BAB6B5'"
							dark
							label=""
							close
							@close="close()"
                            label="Datos de Inventario"
						/>
					</v-row>

					<v-row style="margin-left: 5px" justify="center">
						<v-col cols="12" md="6" lg="6">
							<s-select-definition label="Método de Valorización" return-object  
								v-model="item.EvalSystem" :def="1734" />
						</v-col>
						<v-col cols="12" md="6" lg="6">
							<s-text
								label="Costo del Articulo"
								v-model="item.AvgPrice"								
								decimal
							></s-text>
						</v-col>
					</v-row>
				</v-col>
			</v-card>
		</v-dialog>
    </v-card>
</template>

<script>

    import ServiceInductors from '@/services/FreshProduction/ConfigFresh/InductorsService'

    export default {
        components: {
        
        },
        data() {
            return {
                filter:{
                    ScfCode: ""
                },
                config: {
                    service: ServiceInductors,
                    model: {
                        ItemCode : "ID",
                        // AvgPrice: "decimal"
                    },
                    headers: [
                        // { text: "ID", value: "Id" },
                        { text: "Número de artículo", value: "ItemCode" },
                        { text: "Descripción", value: "ItemName" },
                        { text: "Grupo de artículos", value: "ItmsGrpNam" },
                        { text: "Método de Valorización", value: "EvalSystemName" },
                        { text: "Costo del Articulo", value: "AvgPrice" },
                        { text: "Estado", value: "ItemStatus" },
                    ]  
                },
                itemsSelected: [],
                openModal: false,
                item: {
                    EvalSystem: 2
                },  
            }
        },
        methods:{
            save(){                
                console.log("Filas a modificar",this.itemsSelected);   
                console.log("Metodo de valorizacion",this.item.EvalSystem);            
                // item.save();

                this.ussUserCode = this.$fun.getUserSAPInfo().UssUserCode;

                if(!this.item.AvgPrice > 0) {
                    this.$fun.alert("Error, El Costo del Articulo debe ser mayor a 0 ", "warning")
					return;
                }

                if (this.ussUserCode == null) {
                    this.$fun.alert( "No tiene un Usuario SAP autenticado, Comuniquese con el Área de TECNOLOGÍA DE LA INFORMACIÓN..","warning",);
                    return;
                }

                this.itemsSelected.forEach((element) => {                    
                    element.EvalSystem = this.item.EvalSystem.DedHelper;
                    element.EvalSystemName = this.item.EvalSystem.DedDescription;
                    element.NewEvalSystemName = this.item.EvalSystem.DedHelper2;
                    element.AvgPrice = this.item.AvgPrice;
                    element.UsrCreateID = this.$fun.getUserID();
                });

                console.log("Usuario de Sap",this.$fun.getUserSAPInfo().UsrID);

                this.$fun.alert("Seguro de modificar estos articulos en SAP ? ", "question")
                    .then(r => {
                        if (r.value) {
                            // console.log("Prueba", this.itemsSelected);
                            this.processingSA = true;

                            ServiceInductors
                                .InductorServiceLayer(this.itemsSelected,
                                    this.$fun.getUserSAPInfo().UsrID,
                                    //284,                
                                    this.$fun.getUserID())
                                .then(resp => {
                                    if (resp.status == 200) {
                                        this.processingSA = false;
                                        this.$fun.alert("Subido Correctamente", "success");
                                        this.close();
                                        this.clear();
                                        this.$refs.InductorsList.refresh();
                                    }
                                    
                                },
                                    (e) => {
                                        this.errorSap = true;
                                        this.messageProcessingSAP = e.response.data.Message;
                                        this.processingSA = true;
                                        this.$refs.InductorsList.refresh();
                                    }
                                    
                                );
                        }else{
                            clear();
                            this.$refs.InductorsList.refresh();
                        }
                })
                console.log("Filas a modificadas",this.itemsSelected);

                // this.item.AvgPrice = 0;
                
            },
            clear(){
                this.item.AvgPrice = 0; 
            },
            rowSelected(row){
                console.log("Fila",row);
                this.itemsSelected = row;
            },
            send(){
                console.log("Filas seleccionadas",this.itemsSelected);
                this.openModal = true;
            },
            close() {
				this.openModal = false;				
			},
        }
    }

</script>